import React from "react";

// intl imports
import { useIntl, FormattedNumber } from "react-intl";
import { getLocalizedNameWithIntl } from "../../globals/langHelpers";

// material-ui imports
import { makeStyles } from "@material-ui/core/styles";
import { TableCell, TableRow } from "@material-ui/core";

// internal UI components
import { Value, WinterPricingValue } from "./workOrderDetails";

const SKURow = (props) => {
    const { row, winterPremium } = props;
    const intl = useIntl();
    const cost = row.quantity * row.price;

    return (
        <TableRow>
            <TableCell align="left">
                <Value>{row.productCode}</Value>
            </TableCell>
            <TableCell align="left">{getLocalizedNameWithIntl(intl, { object: row, value: "productDescription" })}</TableCell>
            <TableCell align="left">
                {row?.billingReasonCode ? getLocalizedNameWithIntl(intl, { object: row?.billingReasonCode, value: "name" }) : null}
            </TableCell>
            <TableCell align="left">{row.additionalDetails}</TableCell>
            <TableCell align="right">
                <Value>
                    <FormattedNumber value={row.quantity} style="decimal" />
                </Value>
            </TableCell>
            <TableCell align="right">
                <Value>{row.unitOfMeasure}</Value>
            </TableCell>
            <TableCell align="right">
                {row.winterElligibleSKU && winterPremium ? (
                    <WinterPricingValue>
                        <FormattedNumber value={row.price} style="currency" currency="CAD" currencyDisplay="narrowSymbol" />
                    </WinterPricingValue>
                ) : (
                    <Value>
                        <FormattedNumber value={row.price} style="currency" currency="CAD" currencyDisplay="narrowSymbol" />
                    </Value>
                )}
            </TableCell>
            <TableCell align="right">
                {row.winterElligibleSKU && winterPremium ? (
                    <WinterPricingValue>
                        <FormattedNumber value={row?.cost ? row?.cost : cost} style="currency" currency="CAD" currencyDisplay="narrowSymbol" />
                    </WinterPricingValue>
                ) : (
                    <Value>
                        <FormattedNumber value={row?.cost ? row?.cost : cost} style="currency" currency="CAD" currencyDisplay="narrowSymbol" />
                    </Value>
                )}
            </TableCell>
        </TableRow>
    );
};

export default SKURow;
